import {
    Component,
    OnDestroy,
    OnInit,
    SimpleChanges,
    Input,
} from "@angular/core";
import { SubSink } from "subsink";
import { SharedDataService } from "../../../shared/sharedData.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { forkJoin, Observable, Observer, Subject } from 'rxjs';
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { TemplateService } from "../../../shared/services/template.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TimesheetService } from "../../../shared/services/timesheet.service";
import * as _ from "lodash";

@Component({
    selector: "template-details-filter",
    templateUrl: "./template-details-filter.component.html",
    standalone: false
})
export class TemplateDetailsFilterComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBusService: EventBusService,
        private route: ActivatedRoute,
        private router: Router,
        private templateService: TemplateService,
        private timesheetTemplateService: TimesheetService,
        private _modalService: BsModalService,
        private _sharedDataService: SharedDataService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {}

    buAccess: any;
    templates: any = [];
    templates_list: any = [];
    sub = new SubSink();
    queryContainer: any;
    queryContainer_template: any;
    pageSize: any[] = [10, 25, 50, 100, 250];
    filter = {
        isActive: "Y",
        searchText: "",
        search: {},
        templateTypes: [
            { name: "All Templates", order: "0", value: "All" },
            { name: "Active", order: "1", value: "Y" },
            { name: "Inactive", order: "2", value: "N" },
        ],
    };
    private subs = new SubSink();
    name = "";
    activeStatus = false;
    selectedBuId: any;
    id: any;
    editMode = false;
    disableAddButton = false;
    displayMode = true;
    templateDetails: any = {};
    submitted: any = false;
    isCloneInProgress = false;
    showErrormsg: any = false;
  errorMsg: any = "";
  sports: any = [];
  employeeTypes: any = [];
  dayTypes: any = [];
  workStates: any = [];
  companyCodes: any = [];
  networks: any = [];
  

    getQueryContainer() {
        return {
            query: this.templateService.getTemplateListQuery(
                this.selectedBuId,
                null,
                null,
                null
            ),
        };
    }

    GetQueryContainer_Template() {
        //query: timesheetTemplateService.getPayrollTemplateDetailQuery()
        return {
            query: this.templateService.getPayrollTemplateDetailQuery(
                null,
                null,
                null,
                this.selectedBuId
            ),
        };
    }

    saveObj = {
        id: -1,
        name: "",
        businessUnit: {
            id: "",
        },
        isActive: false,
    };

    openCreateTemplateModal() {}

    addTemplateDetail() {
        this.disableAddButton = true;
        this.log.trace("Get Timesheet Template");
        this.sub.sink = this.templateService
            .addTemplateDetail(this.id)
            .subscribe({
                next: (result) => {
                    //this.templates = result.reference.items;
                    this.log.trace("got results: " + JSON.stringify(result));
                    this.getTemplateDetails();
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showError(
                        "Unable to load the  template Details at this time. Please try again later."
                    );
                },
            });
    }

    setEditMode() {
        this.editMode = true;
        this.displayMode = false;
    }

    setReadMode() {
        this.editMode = false;
        this.displayMode = true;
        this.showErrormsg = false;
        this.getTemplateDetails();
    }

    searchPage(pagesize) {
        this.queryContainer_template.query.pageSize = pagesize;
        this.getTemplateQuerySearch();
    }

    getTemplateQuerySearch() {
        this.getTemplateDetails();
    }

    templateSearch(page: any) {
        this.queryContainer_template.query.currentPage = page.page;
        this.getTemplateDetails();
    }

    //on function getTemplateDetails without parameters -- 20 -12-2022

    getTemplateDetails() {
        this.log.trace("Get Timesheet Template");
        this.sub.sink = this.templateService
            .getAllTemplateDetails(this.queryContainer_template.query)
            .subscribe({
                next: (result) => {
                    //this.templates = result.reference.items;
                    this.templates = result.reference.template;
                    this.templateDetails =
                        result.reference.templateDetails.items;
                    this.name = this.templates.name;
                    this.activeStatus = this.templates.isActive;

                    _.forEach(this.templateDetails, function (item) {
                        item.showcc = item.costCenter ? true : false;
                        item.isWorkStateEnable =
                            item.employeeType.id === "FOREIGN" ||
                            item.employeeType.id === "LOCORP"
                                ? true
                                : false;
                    });

                    // this.data = result.reference.templateDetails;
                    this.queryContainer_template.query.pageSize =
                        result.reference.templateDetails.pageSize;
                    this.queryContainer_template.query.currentPage =
                        result.reference.templateDetails.currentPage;
                    this.queryContainer_template.query.totalRecords =
                        result.reference.templateDetails.totalRecords;
                    _.forEach(this.templateDetails, function (item) {
                        item.originalSortOrder = item.sortOrder;
                        // To set ID of work state
                        item.workState.id = item.workState.description;
                    });

                    //this.disableClearButton = false;
                    this.disableAddButton = false;
                    // templateDetailPromise.resolve();
                    const data = {
                      queryContainer: this.queryContainer_template,
                      data: this.templateDetails,
                      companyCodes: this.companyCodes ,
                      workStates: this.workStates,
                      dayTypes: this.dayTypes,
                      employeeTypes: this.employeeTypes,
                      networks: this.networks,
                      sports: this.sports
                    };

                    this._eventBus.emit(
                        new EmitEvent("getTemplateDetails", "buildGrid", data)
                    );
                },
                error: (err) => {
                    this.log.error(err);
                    this.log.showError(
                        "Unable to load the  template Details at this time. Please try again later."
                    );
                },
            });
    }

    validate() {
        if (_.trim(this.name).length <= 0) {
            return false;
        }
        return true;
    }

    saveTemplate(isValid: any) {
        this.submitted = true;
        if (this.validate()) {
            if (isValid) {
                if (!this.hasTemplateNameUse()) {
                    this.saveOnTemplate(isValid);
                } else {
                    this.submitted = false;
                    this.log.showError(
                        "Template with same name already exists"
                    );
                }
            }
        } else {
            this.showErrormsg = true;
            this.errorMsg = "Please enter a template name.";
            this.submitted = false;
        }
    }

    hasTemplateNameUse() {
        return _.some(this.templates_list, (o) => {
            return (
                _.lowerCase(o.name) === _.lowerCase(this.templates.name) &&
                o.id !== this.templates.id
            );
        });
    }

    saveOnTemplate(isValid) {
        this.isCloneInProgress = true;
        this.log.trace("saveOnTemplate");
        this.submitted = true;
        if (isValid) {
            this.saveObj.id = this.templates.id;
            this.saveObj.name = this.name;
            this.saveObj.businessUnit.id = this.selectedBuId;
            this.saveObj.isActive = this.activeStatus;
            this.sub.sink = this.templateService
                .saveOnTemplateChanges(this.saveObj)
                .subscribe({
                    next: (result) => {
                        this.log.trace(
                            "got results: " + JSON.stringify(result)
                        );
                        this.setReadMode();
                        this.getTemplateDetails();
                    },
                    error: (err) => {
                        this.log.error(err);
                        this.log.showError(
                            "Unable to load the timesheet template at this time.Please try again later."
                        );
                    },
                });
        }
        this.isCloneInProgress = false;
    }

    subscribeEventHandlers() {
        this.sub.sink = this._eventBus.on("onColumnSortClick", (data: any) =>
            this.onSortClicked(data.sortByColumn, data.reverseSort)
        );
    }

    onBusinessUnitSelected(data: any) {
        this.buAccess.businessUnitId = data;
    }

    onSortClicked(sortColumn, reverSort) {
        this.queryContainer_template.query.sortByColumn = sortColumn;
        this.queryContainer_template.query.reverseSort = reverSort;
        this.getTemplateDetails();
    }

    assignContact(listItem) {
        listItem.audit.updateDate = new Date();
        const timecards = [listItem];
        if (!_.isEmpty(listItem.contact)) {
            this.templateService
                .assignContact(this.selectedBuId, timecards)
                .subscribe({
                    next: (result) => {
                        this._eventBusService.emit(
                            new EmitEvent(
                                "details:assignContact",
                                "onUpdateOnContactSelect",
                                listItem
                            )
                        );
                        // this.getTemplateDetails();
                    },
                    error: (err) => {
                        this.log.error(
                            "getTalentTimesheet got an error: " +
                                JSON.stringify(err)
                        );
                    },
                });
        }
    }

    getParams(route) {
        return {
            ...route.params,
            ...route.children.reduce(
                (acc, child) => ({ ...this.getParams(child), ...acc }),
                {}
            ),
        };
  }
  

    ngOnInit() {
        this.subscribeEventHandlers();
        this.id = this.route.snapshot.paramMap.get("id");
        const params = this.getParams(this.router.routerState.snapshot.root);

        if (params["buid"]) {
            this.selectedBuId = params["buid"];
        }

        this.queryContainer_template = this.GetQueryContainer_Template();
        this.queryContainer_template.query.templateId = parseInt(this.id);
        this.queryContainer_template.query.currentPage = 1;
        this._eventBusService.on("assignContact", (listItem) =>
            this.assignContact(listItem)
        );
        this._eventBusService.on("upsertTemplateDeatil", () =>
            this.getTemplateDetails()
        );
        this._eventBusService.on("openModel", () => this.getTemplateDetails());
      

      forkJoin(
        this.templateService.getCompanyCodes(),
        this.templateService.getworkStates(),
        this.templateService.getDayTypes(),
        this.templateService.getEmployeeTypes(),
        this.templateService.getNetworks(),
        this.templateService.getSports()
        
      ).subscribe(([companyResponse, workstateResponse, daytypeResponse, employeetypeResponse, networkResponse, sportsResponse]) => {
        this.companyCodes = companyResponse.reference;
        this.workStates = workstateResponse.reference;
        this.dayTypes = daytypeResponse.reference;
        this.employeeTypes = employeetypeResponse.reference;
        this.networks = networkResponse.reference;
        this.sports = sportsResponse.reference;
        this.getTemplateDetails();
      });

    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
